import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import {
    CheckoutAssistantPage,
    CheckPaymentPage,
    AdvanceTakeawayPaymentPage,
    HomePage,
    MemberHistoryPage,
    NotFoundPage,
    OrderCompletePage,
    OrderReceiptPage,
    OrderSearchPage,
    OrderStatusPage,
    PaymentScreen,
    TablePage,
    MembershipAuthPage,
    EmailVerificationPage,
    // OTPVerificationPage,
    ForceRatingPage,
    RequestPasswordResetPage,
    ResetPasswordPage,
    EmployeeLoginPage,
} from '@pages'
import { ROUTES } from '@common'
import { NonAuthLayoutWrapper, MainLayout, MembershipLayout, NonAuthLayout, CheckoutAssistantLayout } from '@layouts'
import MembershipRedirect from './MembershipRedirect'
import EmployeeProtectedRoute from './EmployeeProtectedRoute'

const router = createBrowserRouter([
    {
        path: '/',
        element: <MainLayout />,
        children: [
            { path: ROUTES.Table.root, element: <TablePage /> },
            { path: ROUTES.Order.number, element: <OrderStatusPage /> },
            { path: ROUTES.Order.search, element: <OrderSearchPage /> },
            { path: ROUTES.Order.receipt, element: <OrderReceiptPage /> },
            { path: ROUTES.Order.history, element: <MemberHistoryPage /> },
            { path: ROUTES.Payment.root, element: <PaymentScreen /> },
            { path: ROUTES.Payment.check, element: <CheckPaymentPage /> },
            { path: ROUTES.AdvanceTakeawayPayment.root, element: <AdvanceTakeawayPaymentPage /> },
            { path: ROUTES.ForceRating.root, element: <ForceRatingPage /> },
            { path: 'not-fount', element: <NotFoundPage /> },
        ],
    },
    {
        path: '/',
        element: <CheckoutAssistantLayout />,
        children: [
            { path: ROUTES.CheckoutAssistant.login, element: <EmployeeLoginPage /> },
            {
                path: ROUTES.CheckoutAssistant.root,
                element: (
                    <EmployeeProtectedRoute>
                        <CheckoutAssistantPage />
                    </EmployeeProtectedRoute>
                ),
            },
        ],
    },
    {
        path: '/',
        element: <NonAuthLayout />,
        children: [{ path: ROUTES.Order.complete, element: <OrderCompletePage /> }],
    },
    {
        path: '/',
        element: <NonAuthLayoutWrapper />,
        children: [{ index: true, element: <HomePage /> }],
    },
    {
        path: '/',
        element: (
            <MembershipRedirect>
                <MembershipLayout />
            </MembershipRedirect>
        ),
        children: [
            { path: ROUTES.Membership.auth, element: <MembershipAuthPage /> },
            { path: ROUTES.Membership.emailVerification, element: <EmailVerificationPage /> },
            { path: ROUTES.Membership.requestPasswordReset, element: <RequestPasswordResetPage /> },
            { path: ROUTES.Membership.resetPassword, element: <ResetPasswordPage /> },
            // { path: ROUTES.Membership.otp, element: <OTPVerificationPage /> },
        ],
    },
    {
        path: '*',
        element: <NotFoundPage />,
    },
])

export default function AppRoutes() {
    return <RouterProvider router={router} />
}
